import { apiCall } from "../../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint, data = null) => apiCall("delete", endpoint, data);

export const getSubIndustryListApi = async (params) => {
  try {
    return await get("sub_industry", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitSubIndustryListApi = async (body) => {
  try {
    return await post("sub_industry", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const deleteSubIndustryListApi = async (id) => {
  try {
    return await del(`sub_industry/delete/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getSubIndustryByIdApi = async (id) => {
  try {
    return await get(`sub_industry/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateSubIndustryListApi = async (id, body) => {
  try {
    return await put(`sub_industry/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const bulkDeleteSubIndustryApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    return await del("sub_industry/bulk_delete", data);
  } catch (err) {
    console.error("Error deleting sub industry:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
